import { IconBox } from '@sloyd/icons';
import { Icon, Row, Text, Wrapper } from './PagePlayground.style';

export type PagePlaygroundProps = {
  entityName: string;
};

export function PagePlayground(props: PagePlaygroundProps) {
  const { entityName } = props;

  return (
    <Wrapper className='PagePlayground-wrapper' data-testid='PagePlayground-wrapper'>
      <Icon>
        <IconBox size={70} stroke={0.2} />
      </Icon>
      <Row>
        <Text>Loading {entityName}...</Text>
      </Row>
    </Wrapper>
  );
}

export default PagePlayground;
